import {isCopilot} from '@github-ui/assignees/copilot-user'
import {useGetHovercardAttributesForType} from '@github-ui/hovercards/use-get-hovercard-attributes-for-type'
import {Label, Link} from '@primer/react'
import {GitHubAvatar} from '@github-ui/github-avatar'
import styles from './TimelineAuthor.module.css'

type Props = {
  login?: string | null
  avatarUrl?: string | null
}

export function TimelineAuthor({login, avatarUrl}: Props) {
  const getHovercardAttributesForType = useGetHovercardAttributesForType()

  if (!login) return null
  const isAI = isCopilot(login)
  const profileUrl = `/${isAI ? 'apps/' : ''}${login}`
  const hovercardAttributes = isAI
    ? getHovercardAttributesForType('copilot', {botSlug: login})
    : getHovercardAttributesForType('user', {login})

  return (
    // margin right here to make sure timeline text lines up correctly when no author
    <span className="mr-1">
      <Link
        href={profileUrl}
        {...hovercardAttributes}
        aria-label={`${login}'s profile`}
        className={`${styles.author} fgColor-default`}
      >
        {avatarUrl && <GitHubAvatar className={styles.avatar} src={avatarUrl} size={16} />}
        <strong className={`fgColor-default${avatarUrl ? ' ml-1' : ''}`}>{login}</strong>
      </Link>
      {isAI && (
        <Label variant="secondary" className="ml-1">
          AI
        </Label>
      )}
    </span>
  )
}
